import { API_ADMIN_URL, API_USER_ADMIN_URL } from './httpClient';
import { importType } from '../massUpload/common';

export const UploadCsvUrl: Record<importType, string> = {
  groups: `${API_ADMIN_URL}/groups/build-tree-from-csv`,
  members: `${API_ADMIN_URL}/users/add-users-to-groups-from-csv`,
  users: `${API_USER_ADMIN_URL}/users/create-users-from-csv`,
  membersToCom: `${API_ADMIN_URL}/csv/import-community-members`,
};
